const SuccessIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.91406 1.71094C11.0547 2.83594 11.625 4.20312 11.625 5.8125C11.625 7.42188 11.0547 8.79688 9.91406 9.9375C8.78906 11.0625 7.42188 11.625 5.8125 11.625C4.20312 11.625 2.82812 11.0625 1.6875 9.9375C0.5625 8.79688 0 7.42188 0 5.8125C0 4.20312 0.5625 2.83594 1.6875 1.71094C2.82812 0.570312 4.20312 0 5.8125 0C7.42188 0 8.78906 0.570312 9.91406 1.71094ZM5.13281 8.88281L9.44531 4.57031C9.63281 4.39844 9.63281 4.22656 9.44531 4.05469L8.92969 3.51562C8.74219 3.34375 8.5625 3.34375 8.39062 3.51562L4.875 7.03125L3.23438 5.39062C3.0625 5.21875 2.88281 5.21875 2.69531 5.39062L2.17969 5.92969C1.99219 6.10156 1.99219 6.27344 2.17969 6.44531L4.61719 8.88281C4.78906 9.07031 4.96094 9.07031 5.13281 8.88281Z"
        fill="#1ABA1A"
      />
    </svg>
  );
};

export default SuccessIcon;
